import { render } from "./blacklist.vue?vue&type=template&id=0d5d5f77&scoped=true"
import script from "./blacklist.vue?vue&type=script&lang=js"
export * from "./blacklist.vue?vue&type=script&lang=js"

import "./blacklist.vue?vue&type=style&index=0&id=0d5d5f77&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5d5f77"]])

export default __exports__